import React from 'react';

import { Title, Container, Subtitle } from './styles';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: false };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    return this.state.errorInfo ? (
      <Container>
        <Title>Ops! Ocorreu um problema no sistema :(</Title>
        <Subtitle>Tente recarregar a página</Subtitle>
      </Container>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
